"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILabelType = void 0;
var ILabelType;
(function (ILabelType) {
    ILabelType["CallToAction"] = "call-to-action";
    ILabelType["SubCategory"] = "sub-category";
    ILabelType["Category"] = "category";
    ILabelType["AltDetail"] = "alt-detail";
    ILabelType["Description"] = "description";
    ILabelType["TitleCallout"] = "title-callout";
    ILabelType["CompletedMessage"] = "completed-message";
})(ILabelType || (exports.ILabelType = ILabelType = {}));
//# sourceMappingURL=label-type.js.map